<script lang="ts">
  import ReceivedPaymentDetailView from '../../../components/admin/payments/ReceivedPaymentDetailView.svelte';

  export let params: { uuid: string };
</script>

<ReceivedPaymentDetailView paymentUuid={params.uuid} />

